import React from "react";
import { StageName, STAGES } from "../../config/offeringCatalog";
import { stageStyles } from "../../config/accentStyles";

interface StageHeaderCellProps {
  stage: StageName;
  includedCount: number;
  newCount: number;
  isCurrent: boolean;
}

const StageHeaderCell: React.FC<StageHeaderCellProps> = ({
  stage,
  includedCount,
  newCount,
  isCurrent,
}) => {
  const style = stageStyles[stage];
  const index = STAGES.indexOf(stage);
  const previous = index > 0 ? STAGES[index - 1] : null;
  const isLast = index === STAGES.length - 1;

  return (
    <div
      className={`flex flex-col justify-end border-l border-t-[3px] border-l-gray-100 dark:border-l-slate-700/50 px-2 pb-3.5 pt-4 text-center md:px-3 ${style.topBorder} ${style.headBg}`}
      data-testid={`stage-header-${stage}`}
    >
      <div className="mb-2 flex h-[18px] items-center justify-center">
        {isCurrent && (
          <span
            className={`rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${style.pill}`}
          >
            You Are Here
          </span>
        )}
      </div>
      <div aria-hidden="true" className="mb-3.5 flex h-3.5 items-center gap-1">
        <span className={`h-[9px] flex-1 ${style.accentBg}`} />
        {!isLast && (
          <span
            className={`h-0 w-0 border-y-[7px] border-l-[9px] border-y-transparent ${style.arrowTip}`}
          />
        )}
      </div>
      <div
        className={`text-[13px] font-bold uppercase tracking-[0.1em] ${style.ink}`}
      >
        {stage}
      </div>
      <div className={`mt-1 text-[11px] font-semibold ${style.ink}`}>
        {includedCount} offerings
      </div>
      <div className="mt-0.5 text-[10.5px] leading-tight text-gray-500 dark:text-gray-400">
        {previous === null ? (
          "Starting point"
        ) : (
          <>
            All of {previous}{" "}
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              +{newCount} new
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default StageHeaderCell;
